/**
 * PRIMEX — assets/primex-ui-enhancements.js (v1.1)
 *
 * Everything here is READ-ONLY with respect to primex-configurator.js's
 * pricing logic: it reads DOM state (#px-width, input[name="px-fcolor"]:checked,
 * #px-price-net, etc.) and either (a) mirrors it into new UI (sidebar, Smart
 * Checkout), or (b) drives the SAME hidden inputs the real engine already
 * reads (#px-design-toggle, #px-dimming) by dispatching real 'change' events,
 * so compute()/writeProps() run exactly as before. No pricing function in
 * primex-configurator.js is modified, wrapped, or duplicated here.
 *
 * v1.1: added an "Erstelle ein Angebot" button next to Add to cart / Buy now.
 * It does NOT create a real quote yet — clicking it opens a "coming soon"
 * popup with a live countdown. Purely cosmetic/informational: no cart
 * property, no price change, nothing pricing-related touched.
 */
(function () {
  'use strict';

  var root = document.getElementById('px-configurator');
  if (!root) return;

  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 13l4 4L19 7"/></svg>';

  function isEn() {
    try {
      var cfgEl = document.getElementById('px-config');
      if (cfgEl) {
        var cfg = JSON.parse(cfgEl.textContent);
        if (cfg && cfg.locale) return cfg.locale === 'en';
      }
    } catch (e) { /* fall through */ }
    return document.documentElement.lang === 'en' || location.pathname.indexOf('/en/') === 0;
  }

  /* =====================================================================
     1. BILD & DRUCK TABS
     ===================================================================== */
  function initImageTabs() {
    var section = document.getElementById('px-textile-section');
    if (!section) return;
    var designWrap = document.getElementById('px-design-wrap');
    var designToggle = document.getElementById('px-design-toggle');
    var uploadWraps = section.querySelectorAll('.px-upload-wrap');
    var hasDualFabric = !!document.getElementById('px-fabric-select2');
    if (!designWrap || !uploadWraps.length || hasDualFabric) return;

    section.classList.add('px-has-tabs');

    var tabs = document.createElement('div');
    tabs.className = 'px-imgtabs';
    tabs.innerHTML =
      '<button type="button" class="px-imgtab is-active" data-px-imgtab="upload">' +
        (isEn() ? 'Upload your own file' : 'Eigene Bilddatei hochladen') +
      '</button>' +
      '<button type="button" class="px-imgtab" data-px-imgtab="catalog">' +
        (isEn() ? 'Choose from catalogue' : 'Bildkatalog wählen') +
      '</button>';
    uploadWraps[0].parentNode.insertBefore(tabs, uploadWraps[0]);

    function setTab(name) {
      tabs.querySelectorAll('[data-px-imgtab]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.pxImgtab === name);
      });
      section.classList.toggle('px-tab-upload', name === 'upload');
      section.classList.toggle('px-tab-catalog', name === 'catalog');
      if (name === 'catalog' && designToggle && !designToggle.checked) {
        designToggle.checked = true;
        designToggle.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (name === 'upload' && designToggle && designToggle.checked) {
        designToggle.checked = false;
        designToggle.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    tabs.querySelectorAll('[data-px-imgtab]').forEach(function (btn) {
      btn.addEventListener('click', function () { setTab(btn.dataset.pxImgtab); });
    });
    setTab('upload');

    var mo = new MutationObserver(function () {
      tabs.style.display = designWrap.style.display !== 'none' ? 'flex' : 'none';
    });
    mo.observe(designWrap, { attributes: true, attributeFilter: ['style'] });
    tabs.style.display = designWrap.style.display !== 'none' ? 'flex' : 'none';
  }

  /* =====================================================================
     2. STEUERUNG TOGGLE (relabelled Dimmung)
     ===================================================================== */
  var steuerungRow = null;
  function initSteuerung() {
    var wrap = document.getElementById('px-dimming-wrap');
    var checkbox = document.getElementById('px-dimming');
    if (!wrap || !checkbox) return;

    var row = document.createElement('div');
    row.className = 'px-toggle-row';
    row.innerHTML =
      '<button type="button" class="px-toggle-btn" data-px-steuerung="ohne">' +
        (isEn() ? 'Without control' : 'Ohne Steuerung') + '<span class="px-toggle-check">' + CHECK_SVG + '</span>' +
      '</button>' +
      '<button type="button" class="px-toggle-btn" data-px-steuerung="mit">' +
        (isEn() ? 'With control' : 'Mit Steuerung') + '<span class="px-toggle-check">' + CHECK_SVG + '</span>' +
      '</button>';
    wrap.parentNode.insertBefore(row, wrap);
    steuerungRow = row;

    wrap.style.position = 'absolute';
    wrap.style.width = '1px';
    wrap.style.height = '1px';
    wrap.style.overflow = 'hidden';
    wrap.style.clip = 'rect(0 0 0 0)';
    wrap.style.whiteSpace = 'nowrap';

    function sync() {
      row.querySelectorAll('[data-px-steuerung]').forEach(function (btn) {
        var wantChecked = btn.dataset.pxSteuerung === 'mit';
        btn.classList.toggle('is-active', checkbox.checked === wantChecked);
      });
    }
    row.querySelectorAll('[data-px-steuerung]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var want = btn.dataset.pxSteuerung === 'mit';
        if (checkbox.checked === want) return;
        checkbox.checked = want;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });
    });
    sync();

    row.style.display = wrap.style.display === 'flex' ? 'flex' : 'none';
  }

  /* =====================================================================
     3. STEP DEFINITIONS shared by in-card badges + sidebar + scrollspy
     ===================================================================== */
  var STEP_ORDER = ['dims', 'color', 'image', 'cable', 'control'];

  function stepDefs() {
    var hasDepth = !!document.getElementById('px-depth');
    return {
      dims: {
        label: isEn()
          ? (hasDepth ? 'Dimensions (W × H × D)' : 'Dimensions (W × H)')
          : (hasDepth ? 'Maße (B × H × T)' : 'Maße (B × H)'),
        sub: isEn()
          ? (hasDepth ? 'Width, height & depth' : 'Width & height')
          : (hasDepth ? 'Breite, Höhe & Tiefe' : 'Breite & Höhe'),
        anchor: function () { return root.querySelector('[data-i18n="dims"], [data-i18n="dims3"]'); },
        visible: function () { return !!this.anchor(); },
        done: function () {
          var err = document.getElementById('px-dim-error');
          var w = document.getElementById('px-width'), h = document.getElementById('px-height');
          if (!w || !h) return true;
          return !!(w.value && h.value) && (!err || !err.textContent.trim());
        }
      },
      color: {
        label: isEn() ? 'Frame colour' : 'Rahmenfarbe',
        sub: isEn() ? 'Choose a colour' : 'Farbe wählen',
        anchor: function () {
          var t = root.querySelector('[data-i18n="frameColor"]');
          return t ? t.closest('.px-label') : null;
        },
        visible: function () { return !!this.anchor(); },
        done: function () { return !!root.querySelector('input[name="px-fcolor"]:checked'); }
      },
      image: {
        label: isEn() ? 'Image & print' : 'Bild & Druck',
        sub: isEn() ? 'Motif & print data' : 'Motiv & Druckdaten',
        anchor: function () { return document.getElementById('px-textile-section'); },
        visible: function () {
          var a = this.anchor();
          if (!a || a.offsetParent === null) return false;
          return !!(root.querySelector('.px-upinput') || document.getElementById('px-design-toggle'));
        },
        done: function () {
          var dt = document.getElementById('px-design-toggle');
          if (dt && dt.checked) {
            return !!root.querySelector('.px-design-panel.px-active-panel input[type="radio"]:checked');
          }
          var files = root.querySelectorAll('.px-upinput'), found = false;
          files.forEach(function (inp) { if (!found && inp.files && inp.files.length) found = true; });
          return found;
        }
      },
      cable: {
        label: isEn() ? 'Cable output' : 'Kabelausgang',
        sub: isEn() ? 'Choose a position' : 'Position wählen',
        anchor: function () { return root.querySelector('[data-i18n="cableLabel"]'); },
        visible: function () { return !!this.anchor(); },
        done: function () { var s = document.getElementById('px-cable-select'); return !!(s && s.value); }
      },
      control: {
        label: isEn() ? 'Control' : 'Steuerung',
        sub: isEn() ? 'With or without' : 'Mit oder ohne',
        anchor: function () { return steuerungRow || document.getElementById('px-dimming-wrap'); },
        visible: function () {
          var w = document.getElementById('px-dimming-wrap');
          return !!w && w.style.display === 'flex';
        },
        done: function () { return true; }
      }
    };
  }

  /* =====================================================================
     4. IN-CARD STEP BADGES (idempotent — safe to call repeatedly)
     ===================================================================== */
  function refreshSteps() {
    var defs = stepDefs();
    var applicable = [];
    STEP_ORDER.forEach(function (key) { if (defs[key].visible()) applicable.push(key); });

    var n = 0;
    STEP_ORDER.forEach(function (key) {
      var d = defs[key];
      var anchor = d.anchor();
      if (!anchor) return;
      var head = anchor.previousElementSibling;
      if (!head || !head.classList || !head.classList.contains('px-step-head') || head.dataset.pxStepKey !== key) {
        head = document.createElement('div');
        head.className = 'px-step-head';
        head.dataset.pxStepKey = key;
        head.innerHTML = '<span class="px-step-num"></span><span class="px-step-title"></span><span class="px-step-check">' + CHECK_SVG + '</span>';
        anchor.parentNode.insertBefore(head, anchor);
      }
      var visible = d.visible();
      head.style.display = visible ? 'flex' : 'none';
      if (!visible) return;
      n++;
      head.querySelector('.px-step-num').textContent = n;
      head.querySelector('.px-step-title').textContent = d.label;
      head.classList.toggle('is-done', d.done());
    });

    renderSidebar(defs, applicable);
    initScrollSpy(defs, applicable);
  }

  /* =====================================================================
     5. LEFT PROGRESS SIDEBAR + SCROLLSPY
     ===================================================================== */
  function renderSidebar(defs, applicableKeys) {
    var nav = document.getElementById('px-progress-sidebar');
    if (!nav) return;
    var n = 0;
    nav.innerHTML = applicableKeys.map(function (key) {
      var d = defs[key];
      n++;
      var done = d.done();
      return '<div class="pxs-step ' + (done ? 'is-done' : '') + '" data-pxs-key="' + key + '">' +
        '<button type="button" class="pxs-link" data-pxs-goto="' + key + '">' +
          '<span class="pxs-dot">' + n + '</span>' +
          '<span><span class="pxs-title-row"><span class="pxs-title">' + d.label + '</span><span class="pxs-check">' + CHECK_SVG + '</span></span><span class="pxs-sub">' + d.sub + '</span></span>' +
        '</button>' +
      '</div>';
    }).join('');
    nav.querySelectorAll('[data-pxs-goto]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = defs[btn.dataset.pxsGoto];
        var el = d && d.anchor();
        if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  var scrollSpyObserver = null;
  function initScrollSpy(defs, applicableKeys) {
    var nav = document.getElementById('px-progress-sidebar');
    if (scrollSpyObserver) { scrollSpyObserver.disconnect(); scrollSpyObserver = null; }
    if (!nav || !('IntersectionObserver' in window)) return;
    scrollSpyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var key = entry.target.__pxsKey;
        nav.querySelectorAll('.pxs-step').forEach(function (el) {
          el.classList.toggle('is-current', el.dataset.pxsKey === key);
        });
      });
    }, { rootMargin: '-15% 0px -70% 0px', threshold: 0 });
    applicableKeys.forEach(function (key) {
      var el = defs[key].anchor();
      if (el) { el.__pxsKey = key; scrollSpyObserver.observe(el); }
    });
  }

  /* =====================================================================
     6. "ERSTELLE EIN ANGEBOT" — coming soon popup with live countdown
     ===================================================================== */
  // Purely informational: no pricing, no cart property, no backend call.
  // The 15-day countdown target is set ONCE per page load (now + 15 days)
  // and simply counts down while the popup is open — it is NOT tied to any
  // real launch date; update PXQ_TARGET_MS below when a real date exists.
  var PXQ_TARGET_MS = Date.now() + 15 * 24 * 60 * 60 * 1000;
  function buildQuoteComingSoonModal() {
    if (document.getElementById('pxq-modal')) return;
    var modal = document.createElement('div');
    modal.id = 'pxq-modal';
    modal.className = 'pxq-modal';
    modal.innerHTML =
      '<div class="pxq-box" role="dialog" aria-modal="true">' +
        '<button type="button" class="pxq-close" id="pxq-close" aria-label="Close">\u2715</button>' +
        '<div class="pxq-icon">\u23F3</div>' +
        '<div class="pxq-title">' + (isEn() ? 'Available soon' : 'Bald verfügbar') + '</div>' +
        '<div class="pxq-sub">' +
          (isEn()
            ? 'Requesting an individual quote directly here will be possible very soon.'
            : 'Ein individuelles Angebot direkt hier anzufragen ist in Kürze möglich.') +
        '</div>' +
        '<div class="pxq-timer" id="pxq-timer"></div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.querySelector('#pxq-close').addEventListener('click', closeQuoteModal);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeQuoteModal(); });
  }
  var pxqTimerInterval = null;
  function openQuoteModal() {
    buildQuoteComingSoonModal();
    var modal = document.getElementById('pxq-modal');
    modal.classList.add('pxq-open');
    document.body.style.overflow = 'hidden';
    function tick() {
      var msLeft = Math.max(0, PXQ_TARGET_MS - Date.now());
      var d = Math.floor(msLeft / 86400000);
      var h = Math.floor((msLeft % 86400000) / 3600000);
      var m = Math.floor((msLeft % 3600000) / 60000);
      var s = Math.floor((msLeft % 60000) / 1000);
      var el = document.getElementById('pxq-timer');
      if (!el) return;
      var dLbl = isEn() ? 'd' : 'T', hLbl = isEn() ? 'h' : 'Std', mLbl = 'm', sLbl = 's';
      el.innerHTML =
        '<div class="pxq-timer-part"><b>' + d + '</b><span>' + dLbl + '</span></div>' +
        '<div class="pxq-timer-part"><b>' + (h < 10 ? '0' + h : h) + '</b><span>' + hLbl + '</span></div>' +
        '<div class="pxq-timer-part"><b>' + (m < 10 ? '0' + m : m) + '</b><span>' + mLbl + '</span></div>' +
        '<div class="pxq-timer-part"><b>' + (s < 10 ? '0' + s : s) + '</b><span>' + sLbl + '</span></div>';
    }
    tick();
    clearInterval(pxqTimerInterval);
    pxqTimerInterval = setInterval(tick, 1000);
  }
  function closeQuoteModal() {
    var modal = document.getElementById('pxq-modal');
    if (modal) modal.classList.remove('pxq-open');
    document.body.style.overflow = '';
    clearInterval(pxqTimerInterval);
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeQuoteModal();
  });

  /* =====================================================================
     7. SMART CHECKOUT — mirrors #px-price, never recomputes it
     ===================================================================== */
  function initSmartCheckout() {
    var container = document.getElementById('px-smart-checkout');
    if (!container) return;

    function findRealForm() {
      var section = root.closest('.shopify-section') || document;
      var f = section.querySelector('form[data-type="add-to-cart-form"]');
      if (f) return f;
      f = document.querySelector('form[data-type="add-to-cart-form"]');
      if (f) return f;
      f = document.querySelector('product-form form[action*="/cart/add"]');
      if (f) return f;
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if (forms[i].querySelector('[name="id"]') && (forms[i].id || '').indexOf('installment') === -1) return forms[i];
      }
      return forms[0] || null;
    }
    function realSubmitButton() {
      var form = findRealForm();
      if (!form) return null;
      return form.querySelector('[type="submit"]') ||
             form.querySelector('button[name="add"]') ||
             form.querySelector('.product-form__submit') ||
             form.querySelector('button, input[type="button"]');
    }
    function allQtyInputs() {
      return Array.prototype.slice.call(document.querySelectorAll('[name="quantity"]'));
    }

    function hideRealQuantityBlocks() {
      document.querySelectorAll('.product-form__quantity').forEach(function (el) {
        el.style.display = 'none';
      });
    }

    container.innerHTML =
      '<div class="pxsc-label">' + (isEn() ? 'Summary' : 'Zusammenfassung') + '</div>' +
      '<div class="pxsc-card">' +
        '<div class="pxsc-head"><b>' + (isEn() ? 'Your configuration' : 'Ihre Konfiguration') + '</b>' +
          '<button type="button" class="pxsc-edit" id="pxsc-edit-btn">' + (isEn() ? 'Edit' : 'Bearbeiten') + '</button></div>' +
        '<div class="pxsc-recap" id="pxsc-recap"></div>' +
        '<div class="pxsc-qty-row">' +
          '<button type="button" data-pxsc-qty="-1" aria-label="' + (isEn() ? 'Decrease quantity' : 'Menge verringern') + '">\u2212</button>' +
          '<div class="pxsc-qty-center">' +
            '<input type="text" id="pxsc-qty-display" readonly aria-label="' + (isEn() ? 'Quantity' : 'Menge') + '">' +
            '<span class="pxsc-qty-pill" id="pxsc-qty-pill"></span>' +
          '</div>' +
          '<button type="button" data-pxsc-qty="1" aria-label="' + (isEn() ? 'Increase quantity' : 'Menge erhoehen') + '">+</button>' +
        '</div>' +
        '<div id="pxsc-price-slot"></div>' +
        '<div id="pxsc-alert-slot"></div>' +
        '<div id="pxsc-buy-slot">' +
          '<button type="button" class="pxsc-cta pxsc-cta-buy" id="pxsc-buy-btn">' + (isEn() ? 'Buy now' : 'Sofort kaufen') + '</button>' +
          '<button type="button" class="pxsc-cta pxsc-cta-cart" id="pxsc-cart-btn"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:16px;height:16px;vertical-align:-3px;margin-right:6px;"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2.5 3h2.4l2.1 11.3a2 2 0 0 0 2 1.7h8.6a2 2 0 0 0 2-1.6l1.3-6.9H6"/></svg>' + (isEn() ? 'Add to cart' : 'In den Warenkorb') + '</button>' +
          '<button type="button" class="pxsc-cta pxsc-cta-quote" id="pxsc-quote-btn">' + (isEn() ? 'Request a quote' : 'Erstelle ein Angebot (B2B)') + '</button>' +
        '</div>' +
      '</div>';

    hideRealQuantityBlocks();

    var realBtnToHide = realSubmitButton();
    if (realBtnToHide) realBtnToHide.style.display = 'none';

    var quoteBtn = document.getElementById('pxsc-quote-btn');
    if (quoteBtn) quoteBtn.addEventListener('click', openQuoteModal);

    function updateQtyDisplay() {
      var qtyDisplay = document.getElementById('pxsc-qty-display');
      var qtyPill = document.getElementById('pxsc-qty-pill');
      var first = allQtyInputs()[0];
      var qty = parseInt((first && first.value) || '1', 10) || 1;
      if (qtyDisplay) qtyDisplay.value = qty;
      if (qtyPill) {
        qtyPill.textContent = isEn()
          ? (qty + (qty === 1 ? ' unit' : ' units'))
          : (qty + ' Stück');
      }
    }

    function renderAll() {
      var priceBlock = document.getElementById('px-price');
      var visible = priceBlock && priceBlock.style.display !== 'none';
      var quote = document.getElementById('px-quote-note');
      var overThreshold = !!(quote && quote.style.display !== 'none' && quote.textContent.trim());

      var netEl = document.getElementById('px-price-net');

      var rows = [];
      var w = document.getElementById('px-width'), h = document.getElementById('px-height'), t = document.getElementById('px-depth');
      if (w && h) {
        rows.push({ label: isEn() ? 'Dimensions' : 'Maße', value: w.value + ' \u00d7 ' + h.value + (t ? ' \u00d7 ' + t.value : '') + ' cm', done: true });
      }
      var colorName = document.getElementById('px-color-name');
      if (colorName) {
        rows.push({ label: isEn() ? 'Frame colour' : 'Rahmenfarbe', value: colorName.textContent || '\u2014', done: true });
      }
      var textileSection = document.getElementById('px-textile-section');
      var textileUsable = false;
      if (textileSection && textileSection.offsetParent !== null) {
        textileUsable = !!(root.querySelector('.px-upinput') || document.getElementById('px-design-toggle'));
      }
      if (textileUsable) {
        var dt = document.getElementById('px-design-toggle');
        var val = isEn() ? 'No file yet' : 'Keine Datei hochgeladen';
        var done = false;
        // v14.38 fix: this never knew about "Unbedruckt/weiß" (Ohne Druck)
        // at all — selecting it still fell through to "no file uploaded",
        // unchecked, even though the customer made a real, deliberate
        // choice. Checked first since it's the state that most clearly
        // rules out the other two.
        var printNoBtn = root.querySelector('.px-print-btn[data-print="NO"]');
        if (printNoBtn && printNoBtn.classList.contains('px-active')) {
          val = isEn() ? 'Unprinted/white' : 'Unbedruckt/weiß';
          done = true;
        } else if (dt && dt.checked) {
          var r = root.querySelector('.px-design-panel.px-active-panel input[type="radio"]:checked');
          if (r) { val = r.dataset.name || val; done = true; }
        } else {
          var f = null;
          root.querySelectorAll('.px-upinput').forEach(function (inp) { if (!f && inp.files && inp.files.length) f = inp.files[0]; });
          if (f) { val = f.name; done = true; }
        }
        rows.push({ label: isEn() ? 'Image & print' : 'Bild & Druck', value: val, done: done });
      }
      var cableSelect = document.getElementById('px-cable-select');
      if (cableSelect && cableSelect.value) {
        rows.push({ label: isEn() ? 'Cable output' : 'Kabelausgang', value: (isEn() ? 'Position ' : 'Position ') + cableSelect.value, done: true });
      }
      var dimCheckbox = document.getElementById('px-dimming');
      var dimWrap = document.getElementById('px-dimming-wrap');
      if (dimCheckbox && dimWrap && dimWrap.style.display === 'flex') {
        rows.push({
          label: isEn() ? 'Control' : 'Steuerung',
          value: dimCheckbox.checked ? (isEn() ? 'With control' : 'Mit Steuerung') : (isEn() ? 'Without control' : 'Ohne Steuerung'),
          done: true
        });
      }
      var recapEl = document.getElementById('pxsc-recap');
      if (recapEl) {
        recapEl.innerHTML = rows.map(function (r) {
          return '<div class="pxsc-row"><span class="k">' + (r.done ? CHECK_SVG : '<span class="pxsc-nocheck"></span>') + ' ' + r.label + '</span><span class="v">' + r.value + '</span></div>';
        }).join('');
      }

      var priceSlot = document.getElementById('pxsc-price-slot');
      if (priceSlot) {
        if (visible && netEl) {
          var grossEl = document.getElementById('px-price-gross');
          var vatEl = document.getElementById('px-vat-note');
          var totalNetEl = document.getElementById('px-total-net');
          var totalGrossEl = document.getElementById('px-total-gross');
          var vatText = vatEl ? vatEl.textContent.trim() : '';
          var netUnitLabel = isEn() ? 'net / unit' : 'netto / Stück';
          var grossUnitLabel = isEn() ? 'gross / unit' : 'brutto / Stück';
          var totalNetLabel = isEn() ? 'Total (net)' : 'Gesamt (netto)';
          var totalGrossLabel = isEn() ? 'Total (gross)' : 'Gesamt (brutto)';
          var qtyInput = allQtyInputs()[0];
          var currentQty = parseInt((qtyInput && qtyInput.value) || '1', 10) || 1;
          var totalQtyLabel = isEn()
            ? ('for ' + currentQty + (currentQty === 1 ? ' unit' : ' units'))
            : ('für ' + currentQty + ' Stück');
          var BOX_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 7.5 12 3l8 4.5v9L12 21l-8-4.5z"/><path d="M4 7.5 12 12l8-4.5M12 12v9"/></svg>';

          priceSlot.innerHTML =
            '<div class="pxsc-price-block">' +
              '<div class="pxsc-price-net"><span class="pxsc-unit-amount">' + netEl.textContent + '</span> <span class="pxsc-unit-label">' + netUnitLabel + '</span></div>' +
              '<div class="pxsc-price-gross"><span class="pxsc-unit-amount">' + (grossEl ? grossEl.textContent : '') + '</span> <span class="pxsc-gross-label">' + grossUnitLabel + '</span></div>' +
              (vatText ? '<div class="pxsc-price-note">' + vatText + '</div>' : '') +
              '<div class="pxsc-price-totals">' +
                '<div class="pxsc-total-row">' +
                  '<span class="pxsc-total-icon">' + BOX_SVG + '</span>' +
                  '<span class="pxsc-total-label-wrap"><span class="pxsc-total-label">' + totalNetLabel + '</span><span class="pxsc-total-sub">' + totalQtyLabel + '</span></span>' +
                  '<strong class="pxsc-total-value">' + (totalNetEl ? totalNetEl.textContent : '') + '</strong>' +
                '</div>' +
                '<div class="pxsc-total-row pxsc-total-row-gross">' +
                  '<span class="pxsc-total-icon pxsc-total-icon-empty" aria-hidden="true"></span>' +
                  '<span class="pxsc-total-label-wrap"><span class="pxsc-total-label">' + totalGrossLabel + '</span><span class="pxsc-total-sub">' + totalQtyLabel + '</span></span>' +
                  '<span class="pxsc-total-value-wrap"><strong class="pxsc-total-value">' + (totalGrossEl ? totalGrossEl.textContent : '') + '</strong>' +
                    (vatText ? '<span class="pxsc-total-vat">' + vatText + '</span>' : '') +
                  '</span>' +
                '</div>' +
              '</div>' +
            '</div>';
        } else {
          priceSlot.innerHTML = '';
        }
      }

      var alertSlot = document.getElementById('pxsc-alert-slot');
      if (alertSlot) {
        alertSlot.innerHTML = overThreshold ? '<div class="pxsc-guest-note">' + quote.textContent + '</div>' : '';
      }
      var slot = document.getElementById('pxsc-buy-slot');
      if (slot) slot.classList.toggle('pxsc-disabled', overThreshold);
      var fbBuy = document.getElementById('pxsc-buy-btn'), fbCart = document.getElementById('pxsc-cart-btn');
      if (fbBuy) fbBuy.disabled = overThreshold;
      if (fbCart) fbCart.disabled = overThreshold;

      updateQtyDisplay();
    }

    container.querySelectorAll('[data-pxsc-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var inputs = allQtyInputs();
        if (!inputs.length) return;
        var v = (parseInt(inputs[0].value, 10) || 1) + parseInt(btn.dataset.pxscQty, 10);
        if (v < 1) v = 1;
        inputs.forEach(function (inp) {
          inp.value = v;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        });
        updateQtyDisplay();
      });
    });
    var editBtn = document.getElementById('pxsc-edit-btn');
    if (editBtn) editBtn.addEventListener('click', function () {
      var firstStep = root.querySelector('.px-step-head');
      if (firstStep) firstStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    container.querySelectorAll('#pxsc-buy-btn, #pxsc-cart-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var real = realSubmitButton();
        if (real) {
          real.click();
          return;
        }
        var form = findRealForm();
        console.error('[PX Smart Checkout] Could not find a real button to trigger Add to Cart.',
          { formFound: !!form, formId: form ? form.id : null, buttonsInForm: form ? form.querySelectorAll('button, input[type=submit]').length : 0 });
      });
    });

    renderAll();
    var priceBlockEl = document.getElementById('px-price');
    if (priceBlockEl && 'MutationObserver' in window) {
      new MutationObserver(renderAll).observe(priceBlockEl, {
        childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style']
      });
    }
    var quoteEl = document.getElementById('px-quote-note');
    if (quoteEl && 'MutationObserver' in window) {
      new MutationObserver(renderAll).observe(quoteEl, {
        attributes: true, attributeFilter: ['style'], childList: true, characterData: true, subtree: true
      });
    }
    allQtyInputs().forEach(function (inp) { inp.addEventListener('change', renderAll); });
  }

  /* =====================================================================
     INIT
     ===================================================================== */
  // v14.40: execution-button wording is now context-aware.
  // - A normal formula product with ONE positive textile choice shows only
  //   "Mit Stoffbanner" (no unnecessary number).
  // - A formula product with MULTIPLE positive fabricModes keeps the count so
  //   choices such as F5/F6 remain distinguishable: "Mit 5 Stoffbanner",
  //   "Mit 6 Stoffbanner".
  // - Handelsware/Messesystem textile slots are a fixed set, not alternative
  //   counts. Their block therefore stays "Ohne Stoffbanner" ->
  //   "Mit Stoffbanner" with no count, and its heading is "Stoffbanner".
  // This changes labels/order presentation only. data-mode/data-count and all
  // pricing inputs remain untouched.
  function setExecButtonLabel(btn, label) {
    if (!btn) return;

    // Single-mode buttons use a translated span; fabricModes buttons use a
    // direct text node before the checkmark SVG. Handle both without replacing
    // the nested checkmark markup.
    var translated = btn.querySelector('[data-i18n="withT"], [data-i18n="withoutT"]');
    if (translated) {
      translated.textContent = label;
      return;
    }

    var textNode = null;
    Array.prototype.forEach.call(btn.childNodes, function (node) {
      if (!textNode && node.nodeType === 3 && (node.nodeValue || '').trim()) textNode = node;
    });
    if (textNode) {
      var leading = (textNode.nodeValue.match(/^\s*/) || [''])[0];
      var trailing = (textNode.nodeValue.match(/\s*$/) || [''])[0];
      textNode.nodeValue = leading + label + trailing;
      return;
    }

    // Plain-text Handelsware button fallback.
    if (!btn.children.length) btn.textContent = label;
  }

  function relabelExecButtonsToStoffbanner() {
    // ----- Normal formula-product Ausführung -----
    var exec = document.getElementById('px-exec');
    if (exec) {
      var buttons = Array.prototype.slice.call(exec.querySelectorAll('.px-exec-btn'));
      var positive = buttons.filter(function (btn) { return btn.dataset.mode !== 'NONE'; });
      var showCounts = positive.length > 1;

      buttons.forEach(function (btn) {
        var isOff = btn.dataset.mode === 'NONE';
        if (isOff) {
          setExecButtonLabel(btn, isEn() ? 'Without fabric banner' : 'Ohne Stoffbanner');
          return;
        }

        // Save the Formula JSON label before we rewrite it. Repeated refreshes
        // can then still recover the original count reliably.
        if (!btn.dataset.pxOriginalExecLabel) {
          btn.dataset.pxOriginalExecLabel = (btn.textContent || '').trim();
        }
        var raw = btn.dataset.pxOriginalExecLabel || '';
        var countMatch = raw.match(/\d+/);
        if (!countMatch) countMatch = (btn.dataset.mode || '').match(/\d+$/);
        var count = countMatch ? countMatch[0] : '';

        var label;
        if (showCounts && count) {
          label = isEn() ? ('With ' + count + ' fabric banners') : ('Mit ' + count + ' Stoffbanner');
        } else {
          label = isEn() ? 'With fabric banner' : 'Mit Stoffbanner';
        }
        setExecButtonLabel(btn, label);
      });
    }

    // ----- Handelsware / Messesystem fixed textile-slot block -----
    var hw = document.getElementById('px-hw-modes');
    if (hw) {
      var hwButtons = Array.prototype.slice.call(hw.querySelectorAll('.px-exec-btn'));
      var offBtn = null;
      hwButtons.forEach(function (btn) {
        var isOff = (parseInt(btn.dataset.count, 10) || 0) === 0;
        if (isOff) offBtn = btn;
        setExecButtonLabel(btn, isOff
          ? (isEn() ? 'Without fabric banner' : 'Ohne Stoffbanner')
          : (isEn() ? 'With fabric banner' : 'Mit Stoffbanner'));
      });

      // This special Stoffbanner block intentionally has the opposite visual
      // order to the normal Ausführung block: Ohne first, Mit second.
      if (offBtn && hw.firstElementChild !== offBtn) hw.insertBefore(offBtn, hw.firstElementChild);

      var hwRoot = document.getElementById('px-hw-textile');
      var hwHeading = hwRoot && hwRoot.querySelector(':scope > .px-label[data-i18n="textilePrinting"]');
      if (hwHeading) hwHeading.textContent = isEn() ? 'Fabric banner' : 'Stoffbanner';
    }
  }
  // v1.2: initImageTabs() (defined above) is now superseded by
  // primex-textile-cards.js's fuller card-based system, which handles
  // upload/catalogue/print together as one shared choice, on every product
  // type that has these options. Left defined, just not called, in case a
  // future product genuinely needs only the simpler tab treatment.
  // initImageTabs();
  initSteuerung();
  relabelExecButtonsToStoffbanner();
  root.classList.add('px-steps-enhanced');
  refreshSteps();

  var refreshTimer;
  function scheduleRefresh() { clearTimeout(refreshTimer); refreshTimer = setTimeout(refreshSteps, 180); relabelExecButtonsToStoffbanner(); }
  root.addEventListener('input', scheduleRefresh);
  root.addEventListener('change', scheduleRefresh);
  root.addEventListener('click', scheduleRefresh);

  initSmartCheckout();
})();